const yRelation = [
  {
    source: 0.01,
    target: 11,
  },
  {
    source: 0.1,
    target: 28,
  },
  {
    source: 0.2,
    target: 37,
  },
  {
    source: 0.6,
    target: 45,
  },
  {
    source: 1,
    target: 54,
  },
  {
    source: 2.5,
    target: 69,
  },
  {
    source: Number.POSITIVE_INFINITY,
    target: 100,
  },
];

const xRelation = [
  {
    source: 0.2,
    target: 21,
  },
  {
    source: 1,
    target: 41,
  },
  {
    source: 2,
    target: 54,
  },
  {
    source: 4,
    target: 67,
  },
  {
    source: Number.POSITIVE_INFINITY,
    target: 100,
  },
];

export default {
  xRelation,
  yRelation,
};
